import React from "react";

const Indemnification = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        M.
        <span className="text-[#01A7D1] "> INDEMNIFICATION AND RELEASE</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <span className="text-lg font-medium">
          YOU AGREE TO DEFEND, INDEMNIFY AND HOLD HARMLESS Yostel, AND ITS
          OFFICERS, MANAGERS, MEMBERS, DIRECTORS, EMPLOYEES, SUCCESSORS,
          ASSIGNS, SUBSIDIARIES, AFFILIATES, SUPPLIERS, AND AGENTS, FROM AND
          AGAINST ANY AND ALL CLAIMS, DAMAGES, OBLIGATIONS, LOSSES, LIABILITIES,
          COSTS OR DEBT, AND EXPENSES (INCLUDING BUT NOT LIMITED TO ATTORNEYS'
          FEES) ARISING FROM YOUR USE OF, ACCESS TO, AND PARTICIPATION IN THE
          PLATFORM; YOUR VIOLATION OF ANY PROVISION OF THE TERMS OF USE,
          INCLUDING THE PRIVACY POLICY; YOUR VIOLATION OF ANY THIRD-PARTY RIGHT,
          INCLUDING WITHOUT LIMITATION ANY COPYRIGHT, PROPERTY, PROPRIETARY,
          INTELLECTUAL PROPERTY, OR PRIVACY RIGHT; OR ANY CLAIM THAT YOUR
          SUBMITTED CONTENT CAUSED DAMAGE TO A THIRD PARTY. THIS DEFENSE AND
          INDEMNIFICATION OBLIGATION WILL SURVIVE THESE TERMS OF SERVICE AND
          YOUR USE OF THE PLATFORM.
        </span>
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <span className="text-lg font-medium">
          THE TERMS OF USE, AND ANY RIGHTS AND LICENSES GRANTED HEREUNDER, MAY
          NOT BE TRANSFERRED OR ASSIGNED BY YOU, BUT MAY BE ASSIGNED BY Yostel
          WITHOUT RESTRICTION.
        </span>
      </p>
    </div>
  );
};

export default Indemnification;
